import React from 'react'
import { Link } from 'react-router-dom'

export default function PageNotFound() {
  return (
    <div className='text-center mt-5 pt-5'>
      <h1 className='display-1' style={{fontSize:150}}>404</h1>
      <p><i>Oops!</i> The page you are looking for does not exist.</p>
      <p><Link to="/">Go back to the homepage</Link></p>
    </div>
  )
}
